var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{class:{
			'custom-control-input': true,
			'is-invalid':
				Object.keys(_vm.validation).length > 0 &&
				(_vm.validation.hasOwnProperty('required') || !_vm.validation.requiredIf) &&
				this.validation.$invalid
					? true
					: false,
		},attrs:{"type":"checkbox","id":_vm.id,"disabled":_vm.disabled != '',"required":_vm.required},domProps:{"value":_vm.value ? true : false,"checked":_vm.current_value},on:{"input":function($event){return _vm.$emit('update:current_value', $event.target.checked)}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":_vm.id}},[_vm._v("\n\t\t"+_vm._s(_vm.label)+"\n\t\t"),(
				Object.keys(_vm.validation).length > 0 &&
					(_vm.validation.hasOwnProperty('required') || !_vm.validation.requiredIf)
			)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()]),_c('validation',{attrs:{"v":_vm.validation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }